import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ChatKeys } from "web_myplann/Api/Chat/ChatKeys";
import { deleteChatsConversationsIdParticipantsMeV2 } from "web_myplann/Infrastructure/Api/Api";
import { processResponse } from "web_myplann/Infrastructure/Api/ApiUtils";

const leaveChatGroup = processResponse((conversationId: number) =>
	deleteChatsConversationsIdParticipantsMeV2(conversationId),
);

export const useLeaveChatGroupMutation = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (conversationId: number) => leaveChatGroup(conversationId),
		onSuccess: (_data, conversationId) => {
			queryClient.removeQueries({
				queryKey: ChatKeys.messages(conversationId),
			});
			queryClient.removeQueries({
				queryKey: ChatKeys.detail(conversationId),
			});
		},
		onSettled: () => {
			queryClient.invalidateQueries({ queryKey: ChatKeys.list() });
		},
	});
};
